"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.submitPackageEnquiry = void 0;
const helpers_1 = require("../../helpers");
const agents_1 = require("../agents");
const getAreaById_1 = require("../areas/getAreaById");
const formatDateFriendly_1 = require("../formatDateFriendly");
const getHotelById_1 = require("../hotel/getHotelById");
const mailchimp_1 = require("../mailchimp");
const sendEmail_1 = require("../sendEmail");
const transfers_1 = require("../transfers");
const users_1 = require("../users");
const getCourseById_1 = require("./getCourseById");
const teeTimeKeyToFriendly_1 = require("./teeTimeKeyToFriendly");
const submitPackageEnquiry = async (supabase, enquiry_obj) => {
    const user = await (0, users_1.createOrFindUser)({
        supabase,
        agent_id: enquiry_obj.agent_id,
        email: enquiry_obj.email,
        first_name: enquiry_obj.first_name,
        last_name: enquiry_obj.last_name,
        phone: enquiry_obj.phone,
        user_type: enquiry_obj.create_account ? "client" : "guest",
        country_of_residence: enquiry_obj.country_of_residence,
        display_currency: enquiry_obj.display_currency,
        site_id: enquiry_obj.site_id,
    });
    if (!user) {
        return { success: false, error: "User Creation Failed" };
    }
    let agent = {};
    // set the client id so this enquiry can be tracked and linked to the user
    enquiry_obj.client_id = user.id;
    if (enquiry_obj.agent_id) {
        agent = await (0, agents_1.getAgentById)(supabase, enquiry_obj?.agent_id);
    }
    try {
        if (enquiry_obj.join_mailing_list) {
            await (0, mailchimp_1.addToMailingList)(enquiry_obj.email, enquiry_obj?.tags || []);
        }
    }
    catch (error) {
        console.log("Failed to add to mailing list", error);
    }
    delete enquiry_obj.join_mailing_list;
    delete enquiry_obj.tags;
    const { data, error } = await supabase
        .from("package_enquiries")
        .insert([enquiry_obj])
        .select()
        .single();
    const errors = [];
    const hotel = await (0, getHotelById_1.getHotelById)(supabase, enquiry_obj.hotel_id);
    let arrival_airport = "";
    if (enquiry_obj.arrival_airport) {
        const arrival_area = await (0, getAreaById_1.getAreaById)(supabase, enquiry_obj.arrival_airport);
        arrival_airport = arrival_area.name.en;
    }
    let departure_airport = "";
    if (enquiry_obj.arrival_airport) {
        const departure_area = await (0, getAreaById_1.getAreaById)(supabase, enquiry_obj.departure_airport);
        departure_airport = departure_area.name.en;
    }
    const courses = [];
    for (const course_id of enquiry_obj.courses) {
        const course = await (0, getCourseById_1.getCourseById)(supabase, course_id);
        courses.push({
            id: course.id,
            name: course.name.en,
        });
    }
    const rate_enquiry_email_obj = {
        language_code: "en",
        template_id: helpers_1.EMAIL_PACKAGE_ENQUIRY,
        data: {
            ...enquiry_obj,
            record_id: data?.id,
            reference: data?.reference,
            date: (0, formatDateFriendly_1.formatDateFriendly)(enquiry_obj.date),
            transfers: (0, transfers_1.transferKeyToFriendly)(enquiry_obj.transfers),
            tee_time: (0, teeTimeKeyToFriendly_1.teeTimeKeyToFriendly)(enquiry_obj.tee_time),
            client: user,
            agent: agent,
            arrival_airport: arrival_airport,
            departure_airport: departure_airport,
            hotel: {
                id: hotel.id,
                name: hotel.name.en,
            },
            courses: courses,
        },
    };
    await (0, sendEmail_1.sendEmail)(rate_enquiry_email_obj);
    const support_rate_enquiry_email_obj = {
        ...rate_enquiry_email_obj,
        template_id: helpers_1.SUPPORT_EMAIL_PACKAGE_ENQUIRY,
        cc_address: ["cpettigrew@gmail.com", "simon@golfsavers.com"],
    };
    await (0, sendEmail_1.sendEmail)(support_rate_enquiry_email_obj);
    if (errors.length > 0) {
        return { success: false, error: errors };
    }
    return {
        success: true,
        data: data,
    };
};
exports.submitPackageEnquiry = submitPackageEnquiry;
